// @REMOVE after fairing removal

// import React, { useEffect, useMemo, useState } from "react";
// import BootstrapModal from "shared/components/BootstrapModal";
// import Spinner from "shared/components/Spinner";

// import api from "api";
// import { Form, Formik } from "formik";
// import * as Yup from "yup";
// import SurveyRadioField from "shared/components/SurveyRadioField";
// import { Button } from "shared/Button";

// const EnquireModal = ({ checkoutToken, isVisible, onDismissed }) => {
//   const [survey, setSurvey] = useState(null);

//   // Load the survey
//   useEffect(() => {
//     const controller = new AbortController();
//     api.get("/shop/checkout/survey", { signal: controller.signal }).then(
//       (data) => {
//         setSurvey(data.data);
//       },
//       (err) => {
//         onDismissed();
//       }
//     );

//     return () => {
//       controller.abort();
//     };
//   }, [onDismissed]);

//   // Generate initial values for the form from the survey questions
//   const initialValues = useMemo(() => {
//     if (!survey) {
//       return null;
//     }

//     return survey.reduce((acc, question) => {
//       acc[question.key] = "";

//       return acc;
//     }, {});
//   }, [survey]);

//   // Generate a validation schema for the form from the survey questions
//   const validationSchema = useMemo(() => {
//     if (!survey) {
//       return null;
//     }

//     return Yup.object().shape(
//       survey.reduce((acc, question) => {
//         let val = Yup.string();

//         if (question.required) {
//           // TODO: Update if we end up supporting more than radio select.
//           val = val.required("Please select an option.");
//         }

//         acc[question.key] = val;
//         return acc;
//       }, {})
//     );
//   }, [survey]);

//   // Our beautiful submit handler, which could be inline on the formik component tbh
//   const onSubmit = async (payload) => {
//     const apiPayload = {
//       responses: Object.keys(payload).map((k) => ({
//         key: k,
//         value: payload[k],
//       })),
//     };

//     try {
//       await api.put(`/shop/checkout/${checkoutToken}/survey`, apiPayload);
//       onDismissed();
//     } catch (e) {}
//   };

//   return (
//     <BootstrapModal isVisible={isVisible} onDismissed={onDismissed}>
//       <div className="modal-header">
//         <button
//           type="button"
//           className="btn-close"
//           data-bs-dismiss="modal"
//           aria-label="Close"
//         ></button>
//       </div>
//       <div className="modal-body">
//         {survey ? (
//           <Formik
//             initialValues={initialValues}
//             onSubmit={onSubmit}
//             validationSchema={validationSchema}
//           >
//             {({ isSubmitting }) => (
//               <Form>
//                 <div>
//                   {survey.map((field) => {
//                     if (field.type !== "radio") {
//                       return null;
//                     }

//                     return (
//                       <SurveyRadioField
//                         key={field.key}
//                         allowOther={field.allow_other}
//                         label={field.label}
//                         name={field.key}
//                         options={field.options}
//                       />
//                     );
//                   })}
//                 </div>
//                 <Button className="mt-3" isLoading={isSubmitting} type="submit">
//                   Submit
//                 </Button>
//               </Form>
//             )}
//           </Formik>
//         ) : (
//           <Spinner />
//         )}
//       </div>
//     </BootstrapModal>
//   );
// };

// export default EnquireModal;

import React from "react";
import BootstrapModal from "shared/components/BootstrapModal";
import Spinner from "shared/components/Spinner";

import "./EnquireModal.scss";

const EnquireModal = ({ isVisible, onDismissed }) => {
  return (
    <BootstrapModal isVisible={isVisible} onDismissed={onDismissed}>
      <div className="modal-header">
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <div id="enquire_labs_target">
          <Spinner />
        </div>
      </div>
    </BootstrapModal>
  );
};

export default EnquireModal;
